import Navbar from "./Navbar";
import Footer from "./Footer";
import LetsGetStarted from "./LetsGetStarted";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import ContantBanner from "./immersion/ContantBanner";
import WhatIsImmersion from "./immersion/WhatIsImmersion";
import ImmersionBenefit from "./immersion/ImmersionBenefit";
import CountriesServeDestination from "./immersion/CountriesServeDestination";
import Testimonial from "./Testimonial";
const imageBaseUrl = process.env.REACT_APP_IMAGE_URL
const icon2 = imageBaseUrl + "p2.png";
const icon4 = imageBaseUrl + "p4.png";
const icon5 = imageBaseUrl + "p1.png";
const icon7 = imageBaseUrl + "p3.png";
const icon8 = imageBaseUrl + "p8.png";
const icon9 = imageBaseUrl + "p9.png";

const Immersion = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Helmet>
        <title>Immersion Services | Taksheela Institute</title>
        <meta
          name="description"
          content="Simplify your Immersion process with Taksheela Institute. Get expert guidance, comprehensive support, and personalized assistance for a smooth transition abroad."
        />
        <meta
          name="keywords"
          content="australia Immersion consultants, best Immersion consultant in india, global Immersion consultant, Immersion agent Canada, top immigration consultants in india"
        />
      </Helmet>
      <Navbar />
      <ContantBanner />
      <WhatIsImmersion />
      <ImmersionBenefit />
      <CountriesServeDestination />
      <Testimonial testimonialCard={testimonialCard} />

      <LetsGetStarted marginTop={6} />
      <Footer />
    </div>
  );
};

export default Immersion;
const testimonialCard = [
  {
    id: 1,
    icon: icon2,
    name: "Pallavi Majumder",
    about: "Doctor of Liberal Arts",
    university: "Hungarian University, Budapest",
    review:
      "With Taksheela’s support, I have received a doctoral position from Hungarian University of Fine Arts, Budapest with full scholarship from Hungarian Government & UGC with a stipend for the entire course of study of the PhD programme."
  },
  {
    id: 2,
    icon: icon4,
    name: "Ankita Shaw",
    about: "M.Sc. In Engineering",
    university: "National University of Singapore",
    review:
      "Secured full scholarship admission for Masters, all thanks to Team Taksheela! Taksheela stands out by providing enduring support until success is achieved."
  },
  {
    id: 3,
    icon: icon5,
    name: "Adrija Dutta",
    about: "MSc Environment and Development",
    university: "London School of Economics",
    review:
      "The methodical arrangement of necessary data, step by step immaculate planning and seamless coordination between the faculty and me, helped me get offer from the top ranked institution in social sciences - LSE. "
  },

  {
    id: 4,
    icon: icon8,
    name: "Yugam Surana",
    about: "Bachelors in EE & Computer Science",
    university: "University of California, Berkeley",
    review:
      "My journey with Taksheela commenced with SAT preparations until finally I scored 1520 and with constant counseling at TIE, I could get into my dream University - UC,Berkeley. "
  },
  {
    id: 5,
    icon: icon9,
    name: "Suvarup Ghosh",
    about: "MSc in Computer Science",
    university: "Ilmenau University of Technology",
    review:
      "Admitted to TU Ilmenau for my Master's in Computer Science in Germany, thanks to Taksheela Institute. Their unwavering support, especially in addressing problems, was crucial. Grateful for their exceptional effort and cooperation. "
  },
  {
    id: 6,
    icon: icon7,
    name: "Hrishi Khemka",
    about: "BSc Business Administration",
    university: "Boston University",
    review:
      "Taksheela's tirelessly assisted with even the smallest queries, guided me through the application process, and meticulously reviewed my essays. Their commitment to highlighting my interests and refining my presentation, ensured I submitted my best work."
  }
];